import type { IEtazhiBlackFridayPricesData } from 'shared/types/etazhiBlackFriday';

/**
 * Код появился к проекту "Чёрная пятница" для компании "Этажи".
 * @todo: удалить в задаче CD-251228
 */
type TEtazhiBlackFridaySetPricesAction = {
  type: 'etazhiBlackFriday/setPricesData';
  payload: IEtazhiBlackFridayPricesData | null;
};

export const setEtazhiBlackFridayPricesData = (
  value: IEtazhiBlackFridayPricesData | null,
): TEtazhiBlackFridaySetPricesAction => ({
  type: 'etazhiBlackFriday/setPricesData',
  payload: value,
});

export type TEtazhiBlackFridayActions = TEtazhiBlackFridaySetPricesAction;
